import { twMerge } from 'tailwind-merge';
import { Container } from '../../../../components/Container/Container';
import { ICoordinates } from '../../../../interfaces/geo';
import { WeatherCarousel } from '../../../../components/WeatherCarousel/WeatherCarousel';
import { getEdgesFromConnection } from '../../../../helpers/graphql';
import {
  GetPlaceTopSpecies_entry_topSpeciesSummary,
  GetPlaceTopSpecies_entry_topSpeciesSummary_edges_node,
  GetPlaceTopSpecies_entry_topSpeciesSummary_edges,
} from '../../../../interfaces/graphql';
import { DYNAMIC_TOP_SPECIES } from '../../../../components/BitetimeDownloadSection/constants/constants';
import { BitetimeDownloadSection } from '../../../../components/BitetimeDownloadSection/BitetimeDownloadSection';

interface IProps {
  className?: string;
  coordinates: ICoordinates;
  id?: string;
  title?: string;
  topSpeciesSummary?: GetPlaceTopSpecies_entry_topSpeciesSummary;
}

export const WeatherSection = ({
  className,
  coordinates,
  id = 'weather-section',
  title = 'Weather',
  topSpeciesSummary,
}: IProps) => {
  const bitetimeTitle = 'Unlock fishing secrets in the app';
  const bitetimeText = 'Discover the best time to fish by species in your area with Bitetime™';

  const speciesEdges = getEdgesFromConnection<
    GetPlaceTopSpecies_entry_topSpeciesSummary_edges_node,
    GetPlaceTopSpecies_entry_topSpeciesSummary_edges
  >(topSpeciesSummary);

  const topSpeciesList = speciesEdges.map(({ node: { _id: id, displayName: label } }) => ({
    id,
    label,
  }));

  const dynamicTopSpeciesArray = topSpeciesList.flatMap(topSpecies => {
    const dynamicTopSpeciesFound = DYNAMIC_TOP_SPECIES.find(species => {
      return topSpecies.id === species.externalID;
    });
    if (dynamicTopSpeciesFound) {
      return dynamicTopSpeciesFound;
    }
    return [];
  });

  const dynamicTopSpecies = dynamicTopSpeciesArray.length > 0 && dynamicTopSpeciesArray[0];

  return (
    <div
      id={id}
      className={twMerge(
        'w-full scroll-mt-(--navigation-scrolltop-offset-mobile) px-6 sm:scroll-mt-(--navigation-scrolltop-offset) sm:px-11',
        className,
      )}
    >
      <Container variant="thin" className="flex flex-col gap-2 px-0 sm:gap-4 sm:px-0">
        <WeatherCarousel coordinates={coordinates} title={title} />
        {dynamicTopSpecies && (
          <BitetimeDownloadSection
            className="rounded-xl"
            title={bitetimeTitle}
            text={bitetimeText}
            topSpecies={dynamicTopSpecies}
          />
        )}
      </Container>
    </div>
  );
};
